<a
  href="{{ pdf?.downloadURL }}"
  reportId="company-research"
  target="_blank"
  trackDownload
  (click)="updatePdfCounter(pdf?.downloadURL)">
  <button class="{{ buttonClasses }}" data-testid="download-pdf-button">Download PDF</button>
</a>
